<template>
	<!-- modal reset password form start -->
  <div v-if="modal" :class=" 'modal is-active'">
    <div class="modal-background"></div>
    <div class="modal-card is-medium">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">Set Your Password</p>	
        <p class="text-center mt-3">Please note that your password rest code will be sent to {{ userDetails.email }}</p>
      </header>
      <section class="modal-card-body ph20">
        <form class="anomymous-form-wrapper">
          <div class="field-group">
            <div class="field">
              <div class="control">
                <validation-provider
                    name="password rest token"
                    ref="token"
                    :rules="{ required: true }"
                  >
                  <template #default="{ errors }">
                    <div class="input-field-with-button">
                      <input
                        name="password rest code"
                        class="input"
                        v-model="form.token"
                        type="text"
                        placeholder="Password rest code"
                      />
                      <a @click.prevent="sendResetPasswordToken()" class="button is-primary send-email-change-code">Send Code</a>
                    </div>
                    <span class="validation-error" v-html="errors[0]"></span>
                  </template>
                </validation-provider>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <validation-provider
                    name="new password"
                    ref="password"
                    rules="required|min:8|verify_password"
                    vid="password"
                  >
                  <template #default="{ errors }">
                    <input
                      name="new password"
                      class="input"
                      v-model="form.password"
                      type="password"
                      placeholder="New password"
                    />
                    <span class="validation-error" v-html="errors[0]"></span>
                  </template>
                </validation-provider>
            </div>
          </div>
          <div class="field">
              <div class="control">
                <validation-provider
                    name="re-enter new password"
                    ref="password_confirmation"
                    rules="required|confirmed:password"
                  >
                  <template #default="{ errors }">
                    <input
                      name="re-enter new password"
                      class="input"
                      v-model="form.password_confirmation"
                      type="password"
                      placeholder="Re-enter New Password"
                    />
                    <span class="validation-error" v-html="errors[0]"></span>
                  </template>
                </validation-provider>
            </div>
          </div>
        </div>
        </form>
      <!-- form end -->
      </section>
      <footer class="modal-card-foot">
        <button @click="updatePassword()" class="button is-large is-primary is-full-width">Save Password</button>
      </footer>
    </div>
  </div>
	<!-- modal  reset password  form end -->
</template>

<script>
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
import UserApis from '@/Components/Controllers/UserApis';
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      modal: false,
      form: {
        site_url: window.location.hostname ? window.location.hostname : window.location.href,
        token : "",
        password: "",
        password_confirmation : "",

        business_id: '',
        business_name: '',
        business_slug: '',
        logo_url: '',
        location_id: '',
        location_slug: '',
      }
    };
  },

  computed: {
    ...mapGetters({
      vg_businessProfile: "businessprofile/detail", 
      vg_selectedStore: "location/selected",
    }),
    userDetails() {
      return this.$store.getters.getLoggedInUser;
    },
    /**
     * Get user is normal or anonymous
     */
    isAnonymousUser() {
      if(this.userDetails.email.includes('@anonymous.com')){
        return true;
      }
      return false;
    },
  },

  mounted() {
    bus.$on('show-modal-change-password', (payload) => {
      this.modal = payload;
    })
  },

  beforeDestroy() {
    bus.$off('show-modal-change-password');
  },

  methods: {
    /**
    * Send resetpassword token
    */
    async sendResetPasswordToken() {
      // Check before api hit
      if(this.isAnonymousUser){
        return this.va_snackbar({
          type: 'error',
          message: 'Please change your email address first. Email address seems invalid.',
        });
      }
      if(!this.userDetails.email){
        return this.va_snackbar({
          type: 'error',
          message: 'Sorry cannot find user email.',
        });
      }
      let res = await UserApis.changePasswordGenerateToken({
        email: this.userDetails.email,
        // Extra need to pass
        business_id: this.vg_businessProfile.id,
        business_name: this.vg_businessProfile.name,
        business_slug: this.$route.params.business_slug,
        logo_url: (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '',
        location_id: this.vg_selectedStore.id ? this.vg_selectedStore.id : '',
        location_slug: this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '',
      });
      this.va_snackbar({
        type: res.status == 200 ? 'success' : 'warning',
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
      });
    },
    /**
     * Update password
     */
    async updatePassword() {
      let validation = await Helpers.validateRefs(this, ['token', 'password', 'password_confirmation']);
      if( validation ) {
        let host = window.location.protocol + "//" + window.location.host;
        this.form.site_url = host + '/' + this.$route.params.business_slug;
        // Extra need to pass
        this.form.business_id = this.vg_businessProfile.id;
        this.form.business_name = this.vg_businessProfile.name;
        this.form.business_slug = this.$route.params.business_slug;
        this.form.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
        this.form.location_id = this.vg_selectedStore.id ? this.vg_selectedStore.id : '';
        this.form.location_slug = this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '';

        let res = await UserApis.resetPasswordWithVerificationToken(this.form);
        if(res.status == 200){
          this.form = Helpers.setObjValueEmpty(this.form);
          this.closeModal();
          this.$store.dispatch('REMOVE_APP_DATA', '');
          setTimeout(() => {
            // Now logout user
            this.va_snackbar({
              type: 'success',
              message:  res.data.msg + ' Please login again.',
            });
            this.va_setLoginModal(true);
            // Redirect
            if(_.isEmpty(this.vg_selectedStore.slug)){
              this.$router.push({ name: 'HomePage', param: { business_slug: this.$route.params.business_slug }});
            } else {
              if(this.$route.name != 'StoreProfile'){
                this.$router.push({ name: 'StoreProfile', params: { business_slug:  this.$route.params.business_slug,  store_slug: this.vg_selectedStore.slug } })
              } else {
                // fallback homepage
                this.$router.push({ name: 'HomePage', param: { business_slug: this.$route.params.business_slug }});
              }
            }
          }, 500)
        } else {
          this.va_snackbar({
            type: res.status == 200 ? 'success' : 'warning',
            message: res.status == 200 ? res.data.msg : res.response.data.msg,
          });
        }
      }
    },

    closeModal() {
      this.modal = false;
      this.form = Helpers.setObjValueEmpty(this.form);
    },

    ...mapActions({
      // spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setLoginModal: "loginmodal/setModal",
    })
  },
};
</script>